import React, { useEffect, useState } from "react";
import "../../Completed/QuestionCompleted/QuestionType.css";
import CheckBoxType from "./CheckBoxType";
import SubmisshionByUpload from "./SubmisshionByUpload";
import { useSelector } from "react-redux";
import axios from "../../../../axios";
import { useParams, useLocation } from "react-router-dom";
import VerticalProgBar from "../../Pending/VarticalProgressBar/VerticalProgBar";
import AdaptiveEvalutionGraph from "./AdaptiveEvalutionGraph";
import FailedApiPopup from "./FailedApiPopup";
import PopupforNoQsAttempt from "./PopupforNoQsAttempt";

export default function AllQuestions({
  assessmentId: propAssessmentId,
  handleViewAnswerQuestionFalse,
  FromSummaryUpdate,
  completeAss,
}) {
  const { assessmentId: paramsAssessmentId } = useParams();
  const assessmentId = propAssessmentId || paramsAssessmentId;

  const [resultData, setResultData] = useState([]);
  const [isGettingData, setIsGettingData] = useState(true);
  const userId = useSelector((state) => state.user?.currentUser?.id);
  const [studentResultData, setStudentResultData] = useState([]);
  const [openGraphPopup, setOpenGraphPopup] = useState(false);
  const [studentMarksDetails, setStudentMarksDetails] = useState([]);
  const [questionNo, setQuestionNo] = useState(0);
  const [skillsValue, setSkillsValue] = useState(0);
  const [chartData, setChartData] = useState();
  const [failedApiPopup, setFailedApiPopup] = useState(false);
  const [popupOpen, setPopupOpen] = useState(false);
  const [difficulty, setDifficulty] = useState(0);

  const difficultyLevels = ["Very Hard", "Hard", "Medium", "Easy", "Very Easy"];
  const skillsLevels = [
    "Create",
    "Evalute",
    "Analyze",
    "Apply",
    "Understand",
    "Remember",
  ];

  useEffect(() => {
    getStudentResponse();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assessmentId, userId]);

  const getStudentResponse = async () => {
    try {
      let res = await axios.get(
        `/assessment/${assessmentId}/studentResult/student/${userId}/get`,
      );
      if (res) {
        let content = res?.data?.data;
        if (content.assessment.isAdaptive) {
          if (res?.data?.data?.difficulty_history.length === 0) {
            setPopupOpen(true);
            return;
          }
          let questions = res?.data?.data?.results;
          content.results = null;
          let newQuestion = [];
          for (let i = 0; i < content.difficulty_history.length; i++) {
            newQuestion.push(
              questions[content.difficulty_history[i].questionNo],
            );
          }
          content.results = newQuestion;
        }

        let resultes = content.results;
        setResultData(resultes);
        setStudentResultData(content);
        let qsNoLabels = [];

        if (res.data.data.assessment) {
          const resultArray = resultes.map((curr, index) => {
            const resultObj = { questionNumber: `Q${index + 1}` };
            qsNoLabels.push(resultObj.questionNumber);
            return resultObj;
          });
          setChartData(resultArray);
        }
      }
      setIsGettingData(false);
    } catch (error) {
      setFailedApiPopup(true);
      setIsGettingData(false);
      console.log(error);
    }
  };

  useEffect(() => {
    const getStudentMarksDetails = async () => {
      try {
        const res = await axios.get(
          `/assessment/${assessmentId}/studentScoreBoard/get/studentId/${userId}`,
        );
        res && setStudentMarksDetails(res?.data?.data);
        setIsGettingData(false);
      } catch (error) {
        setIsGettingData(false);
      }
    };
    getStudentMarksDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const timeHelper = (a) => {
    if (!a) return null;
    const dateObj = new Date(a);
    const userOffset = dateObj.getTimezoneOffset() * 60000;
    const localDate = new Date(dateObj - userOffset);
    const day = localDate.getDate().toString().padStart(2, "0");
    const month = (localDate.getMonth() + 1).toString().padStart(2, "0");
    const year = localDate.getFullYear();
    return `${day}/${month}/${year}`;
  };

  useEffect(() => {
    if (resultData.length > 0) {
      getDifficultyName(resultData);
    }
  }, [questionNo, resultData]);

  const getDifficultyName = (resultes) => {
    const questionTypeMap = {
      "Very Easy": 1,
      Easy: 2,
      Medium: 3,
      Difficult: 4,
      "Very Difficult": 5,
    };
    const questionTypeMapSkill = {
      Create: 6,
      Evaluate: 5,
      Analyze: 4,
      Apply: 3,
      Understand: 2,
      Remember: 1,
    };
    let currectQues = [];
    for (let i = 0; i < resultes.length; i++) {
      if (questionNo === i) currectQues.push(resultes[i]);
    }
    setDifficulty(
      questionTypeMap[
        currectQues[0]?.question_response?.question?.difficulty_level?.name
      ] || 0,
    );
    setSkillsValue(
      questionTypeMapSkill[
        currectQues[0]?.question_response?.question?.skill?.name
      ] || 0,
    );
  };

  const handleRouteBack = () => {
    if (FromSummaryUpdate === "FromSummaryUpdate") {
      window.history.back();
    } else {
      handleViewAnswerQuestionFalse();
    }
  };

  if (isGettingData) {
    return (
      <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-slate-900/50 backdrop-blur-sm">
        <div className="bg-white p-6 rounded-xl shadow-xl">
          <img
            className="w-16 h-16"
            src="/gif/LoaderDot.gif"
            alt="Loading..."
          />
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 z-[9999] bg-slate-900/50 backdrop-blur-sm flex items-center justify-center p-2 md:p-6 overflow-hidden">
      <div className="bg-[#f5f7fa] w-full max-w-[1400px] h-full max-h-[95vh] rounded-2xl shadow-2xl flex flex-col overflow-hidden">
        {/* =========================================
            FIXED HEADER SECTION (No Scroll)
           ========================================= */}
        <div className="shrink-0 bg-white border-b border-slate-200 px-5 py-4 md:px-6 md:py-5 flex flex-col gap-3 rounded-t-2xl">
          <div className="flex flex-col md:flex-row md:items-start justify-between gap-4">
            {/* Left Side: Title & Meta */}
            <div className="flex flex-col gap-1.5">
              <div className="flex items-center gap-2 flex-wrap">
                <button
                  onClick={handleRouteBack}
                  className="text-slate-500 hover:text-red-500 transition-colors p-1 -ml-2 rounded-lg hover:bg-red-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-red-400"
                  title="Close"
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M18 6L6 18M6 6L18 18"
                      stroke="currentColor"
                      strokeWidth="2.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
                <h1 className="text-[17px] md:text-[19px] font-bold text-slate-800 leading-tight m-0">
                  {studentResultData?.assessment?.name}
                </h1>
                <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-emerald-600 text-white text-[11px] font-semibold shadow-sm">
                  <span className="w-1.5 h-1.5 rounded-full bg-white/90" />
                  Completed
                </span>
                {completeAss?.checkAdaptive && (
                  <img
                    src="/images/adaptiveImg.png"
                    alt="Adaptive"
                    className="h-5 w-auto"
                  />
                )}
                {completeAss?.checkAutoEvalution && (
                  <img
                    src="/images/auto-eva.png"
                    alt="Auto Evaluated"
                    className="h-5 w-auto"
                  />
                )}
              </div>

              <div className="flex flex-wrap items-center gap-x-3 gap-y-1 mt-1 text-[13px]">
                <span className="font-semibold text-slate-700">
                  {studentResultData?.assessment?.subject_id?.name}
                </span>
                <span className="text-slate-300 hidden sm:inline">|</span>
                <span className="inline-flex items-center gap-1.5">
                  <span className="text-slate-500 font-medium">Submitted</span>
                  <span className="font-semibold text-slate-700">
                    {timeHelper(studentResultData?.submitted_on)}
                  </span>
                </span>
                <span className="text-slate-300 hidden sm:inline">|</span>
                <span className="inline-flex items-center gap-1.5">
                  <span className="text-slate-500 font-medium">
                    Evaluated on
                  </span>
                  <span className="font-semibold text-slate-700">
                    {timeHelper(studentResultData?.evaluation_on)}
                  </span>
                </span>
              </div>
            </div>

            {/* Right Side: Score & Show Summary */}
            <div className="flex items-center gap-4 shrink-0">
              <div className="text-right">
                <div className="text-[11px] font-bold text-slate-400 uppercase tracking-wider mb-0.5">
                  Score
                </div>
                <div className="text-2xl font-extrabold text-[#335c76] leading-none">
                  {studentResultData?.obtained_marks || 0}
                  <span className="text-[15px] font-semibold text-slate-400">
                    /{studentResultData?.assessment?.total_marks || 0}
                  </span>
                </div>
              </div>
              <button
                onClick={() => setOpenGraphPopup(true)}
                className="inline-flex items-center gap-2 px-4 py-2 bg-orange-500 hover:bg-orange-600 text-white text-sm font-semibold rounded-lg shadow-sm shadow-orange-500/30 transition-all hover:-translate-y-0.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange-400"
              >
                Show Summary
              </button>
            </div>
          </div>
        </div>

        {/* =========================================
            SCROLLABLE CONTENT SECTION
           ========================================= */}
        <div className="flex-1 overflow-y-auto p-3 md:p-5 custom-scrollbar">
          <div className="max-w-[1400px] mx-auto flex flex-col gap-4">
            {/* Navigator Card */}
            <div className="bg-white rounded-xl border border-slate-200 shadow-sm px-4 py-3 md:px-5 flex items-center justify-between gap-4 flex-wrap">
              <div className="aq-nav-scroll flex items-center gap-2 overflow-x-auto pb-1 flex-1 min-w-0">
                {resultData?.length > 0 &&
                  resultData?.map((item, index) => {
                    const isCurrent = questionNo === index;
                    const isCompleted = questionNo > index;
                    const isMandatory =
                      item?.question_response?.question?.is_mandatory;
                    return (
                      <button
                        key={index}
                        onClick={() => setQuestionNo(index)}
                        className={[
                          "relative flex-shrink-0 min-w-[40px] h-9 px-3 rounded-lg border-[1.5px] text-sm font-semibold transition-all",
                          isCurrent
                            ? "border-orange-400 bg-orange-50 text-orange-600 shadow-sm"
                            : isCompleted
                              ? "border-orange-300 bg-orange-50/40 text-orange-500 hover:border-orange-400"
                              : "border-slate-200 bg-white text-slate-500 hover:border-orange-300 hover:text-orange-500",
                        ].join(" ")}
                      >
                        Q{index + 1}
                        {isMandatory && (
                          <span className="absolute -top-1 -right-1 w-2.5 h-2.5 rounded-full bg-red-600 border-2 border-white" />
                        )}
                      </button>
                    );
                  })}
              </div>
              <div className="flex items-center gap-2 shrink-0">
                {questionNo >= 1 && (
                  <button
                    onClick={() => setQuestionNo(questionNo - 1)}
                    className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-white border border-orange-300 rounded-lg text-sm font-semibold text-orange-500 transition-all hover:bg-orange-50"
                  >
                    Previous
                  </button>
                )}
                {resultData?.length > questionNo + 1 && (
                  <button
                    onClick={() => setQuestionNo(questionNo + 1)}
                    className="inline-flex items-center gap-1.5 px-4 py-1.5 bg-orange-500 hover:bg-orange-600 text-white rounded-lg text-sm font-semibold shadow-sm transition-all"
                  >
                    Next
                  </button>
                )}
              </div>
            </div>

            {/* Question Content Card Wrapper */}
            <div className="mt-4 allquestionTypesContainer d-flex">
              {/* Left Side (Question) */}
              <div
                style={{
                  flex: studentResultData?.assessment?.isAdaptive
                    ? "0 0 60%"
                    : "0 0 100%",
                }}
              >
                {!resultData[questionNo]?.question_response?.question?.type
                  ?.is_manually_graded ? (
                  <CheckBoxType
                    questionNo={questionNo + 1}
                    response={resultData[questionNo]}
                    isAdaptiveCheck={studentResultData?.assessment?.isAdaptive}
                  />
                ) : (
                  <SubmisshionByUpload
                    questionNo={questionNo + 1}
                    response={resultData[questionNo]}
                    isAdaptiveCheck={studentResultData?.assessment?.isAdaptive}
                    showEvaluationCriteria={
                      studentResultData?.showEvaluationCriteria
                    } // <--- YE NAYA PROP PASS KIYA HAI
                  />
                )}
              </div>

              {/* Right Side (Adaptive Metrics) */}
              {studentResultData?.assessment?.isAdaptive && (
                <div style={{ flex: "0 0 40%" }}>
                  <div
                    style={{
                      display: "flex",
                      marginTop: "42px",
                      justifyContent: "center",
                    }}
                  >
                    <VerticalProgBar
                      title="Difficulty"
                      levels={difficultyLevels}
                      progress={difficulty * 20}
                    />
                    <VerticalProgBar
                      title="Skills"
                      levels={skillsLevels}
                      progress={skillsValue * 16.67}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* POPUPS */}
      {openGraphPopup && (
        <AdaptiveEvalutionGraph
          studentResultData={studentResultData}
          chartData={chartData}
          studentMarksDetails={studentMarksDetails}
          setOpenGraphPopup={setOpenGraphPopup}
          assessmentisAdaptive={studentResultData?.assessment?.isAdaptive}
        />
      )}
      {failedApiPopup && <FailedApiPopup handleRouteBack={handleRouteBack} />}
      {popupOpen && <PopupforNoQsAttempt handleRouteBack={handleRouteBack} />}
    </div>
  );
}
